export default {
  popularCategories: [
    {
      value: 'Electricians',
      key: '/find/electricians'
    },
    {
      value: 'Plumbers',
      key: '/find/plumbers'
    },
    {
      value: 'Handyman',
      key: '/find/handyman'
    },
    {
      value: 'Builders',
      key: '/find/builders'
    },
    {
      value: 'Painters',
      key: '/find/painters'
    },
    {
      value: 'House Cleaning',
      key: '/find/cleaning_services'
    }
  ],
  categories: [
    {
      value: 'Air Conditioning',
      key: '/find/air_conditioning'
    },
    {
      value: 'Arborists',
      key: '/find/arborists'
    },
    {
      value: 'Architects',
      key: '/find/architects'
    },
    {
      value: 'Asbestos Removal',
      key: '/find/asbestos_removal'
    },
    {
      value: 'Awnings',
      key: '/find/awnings'
    },
    {
      value: 'Balustrades',
      key: '/find/balustrades'
    },
    {
      value: 'Bathroom Renovations',
      key: '/find/bathroom_renovations'
    },
    {
      value: 'Blind Suppliers',
      key: '/find/blinds_suppliers'
    },
    {
      value: 'Blinds',
      key: '/find/blinds'
    },
    {
      value: 'Bricklayers',
      key: '/find/bricklayers'
    },
    {
      value: 'Building Designers',
      key: '/find/building_designers'
    },
    {
      value: 'Building Inspections',
      key: '/find/inspection_services'
    },
    {
      value: 'Cabinet Makers',
      key: '/find/cabinet_makers'
    },
    {
      value: 'Carpenters',
      key: '/find/carpenters'
    },
    {
      value: 'Carpet Cleaning',
      key: '/find/carpet_cleaning'
    },
    {
      value: 'Carports',
      key: '/find/carports'
    },
    {
      value: 'Cladding',
      key: '/find/cladding'
    },
    {
      value: 'Commercial Cleaning',
      key: '/find/commercial_cleaning'
    },
    {
      value: 'Concrete Resurfacing',
      key: '/find/concrete_resurfacing'
    },
    {
      value: 'Concreting',
      key: '/find/concretors'
    },
    {
      value: 'Curtains',
      key: '/find/curtains'
    },
    {
      value: 'Decking',
      key: '/find/decking'
    },
    {
      value: 'Demolition',
      key: '/find/demolition'
    },
    {
      value: 'Doors',
      key: '/find/doors'
    },
    {
      value: 'Drafting',
      key: '/find/drafters'
    },
    {
      value: 'Excavation',
      key: '/find/excavation'
    },
    {
      value: 'Extension Design',
      key: '/find/home_renovations_design'
    },
    {
      value: 'Fencing',
      key: '/find/fences'
    },
    {
      value: 'Garages',
      key: '/find/garages'
    },
    {
      value: 'Garden Clean Up',
      key: '/find/garden_maintenance_garden_cleanup'
    },
    {
      value: 'Gardeners',
      key: '/find/garden_maintenance'
    },
    {
      value: 'Gas Fitters',
      key: '/find/gas_fitters'
    },
    {
      value: 'Gates',
      key: '/find/gates'
    },
    {
      value: 'Gazebo',
      key: '/find/gazebo'
    },
    {
      value: 'Glazier',
      key: '/find/glass_glazier'
    },
    {
      value: 'Gutter Cleaning',
      key: '/find/gutter_cleaning'
    },
    {
      value: 'Guttering',
      key: '/find/guttering'
    },
    {
      value: 'Home Security',
      key: '/find/security'
    },
    {
      value: 'Home Theatre',
      key: '/find/home_theatre'
    },
    {
      value: 'Hot Water Systems',
      key: '/find/hot_water_systems'
    },
    {
      value: 'Insulation',
      key: '/find/insulation'
    },
    {
      value: 'Interior Decorators',
      key: '/find/interior_decorator'
    },
    {
      value: 'Interior Designers',
      key: '/find/interior_designer'
    },
    {
      value: 'Irrigation Systems',
      key: '/find/irrigation_systems'
    },
    {
      value: 'Kitchens',
      key: '/find/kitchen_renovations'
    },
    {
      value: 'Landscapers',
      key: '/find/landscaper_gardener'
    },
    {
      value: 'Lawn & Turf',
      key: '/find/lawn_turf'
    },
    {
      value: 'Lawn Mowing',
      key: '/find/lawn_mowing'
    },
    {
      value: 'Lighting',
      key: '/find/lighting'
    },
    {
      value: 'Patios',
      key: '/find/patios'
    },
    {
      value: 'Pavers',
      key: '/find/paver'
    },
    {
      value: 'Pergolas',
      key: '/find/pergola'
    },
    {
      value: 'Pest Control',
      key: '/find/pest_control'
    },
    {
      value: 'Plastering',
      key: '/find/plastering'
    },
    {
      value: 'Pool Fencing',
      key: '/find/pool_fencing'
    },
    {
      value: 'Pressure Cleaner',
      key: '/find/pressure_cleaner'
    },
    {
      value: 'Rain Water Tanks',
      key: '/find/rainwater_tanks'
    },
    {
      value: 'Removalists',
      key: '/find/furniture_removal'
    },
    {
      value: 'Render',
      key: '/find/render'
    },
    {
      value: 'Rendering',
      key: '/find/renderer'
    },
    {
      value: 'Retaining Walls',
      key: '/find/retaining_walls'
    },
    {
      value: 'Roof Repairs',
      key: '/find/roof_repairs'
    },
    {
      value: 'Roofing',
      key: '/find/roofing'
    },
    {
      value: 'Rubbish Removal',
      key: '/find/rubbish_remover'
    },
    {
      value: 'Security Screen Doors',
      key: '/find/security_screens_doors'
    },
    {
      value: 'Shopfitters',
      key: '/find/shop_fitters'
    },
    {
      value: 'Shower Screens',
      key: '/find/shower_screens'
    },
    {
      value: 'Skylights',
      key: '/find/skylights'
    },
    {
      value: 'Solar Power',
      key: '/find/solar_power'
    },
    {
      value: 'Splashbacks',
      key: '/find/splashbacks'
    },
    {
      value: 'Tilers',
      key: '/find/tilers'
    },
    {
      value: 'Timber Flooring',
      key: '/find/timber_flooring'
    },
    {
      value: 'Tree Fellers',
      key: '/find/tree_fellers'
    },
    {
      value: 'Verandahs',
      key: '/find/verandahs'
    },
    {
      value: 'Wardrobes',
      key: '/find/wardrobes'
    },
    {
      value: 'Waterproofing',
      key: '/find/waterproofers'
    },
    {
      value: 'Window Cleaners',
      key: '/find/window_cleaners_standard'
    },
    {
      value: 'Window Repair',
      key: '/find/window_repairs'
    },
    {
      value: 'Window Tinting',
      key: '/find/window_tinting'
    },
    {
      value: 'Windows',
      key: '/find/windows'
    }
  ],
  photoCategories: [
    {
      key: '/photos/bathrooms',
      value: 'Bathrooms'
    },
    {
      key: '/photos/exteriors',
      value: 'Exteriors'
    },
    {
      key: '/photos/gardens',
      value: 'Gardens'
    },
    {
      key: '/photos/kitchens',
      value: 'Kitchens'
    },
    {
      key: '/photos/pools',
      value: 'Pools'
    },
    {
      key: '/photos/decking',
      value: 'Timber Decks'
    }
  ],
  articleCategories: [
    {
      key: '/c/kitchens',
      value: 'Kitchens'
    },
    {
      key: '/c/bathrooms',
      value: 'Bathrooms'
    },
    {
      key: '/c/gardening',
      value: 'Gardening'
    },
    {
      key: '/c/building',
      value: 'Building'
    },
    {
      key: '/c/decking',
      value: 'Decking'
    }
  ],
  costGuides: [
    {
      value: 'Pools',
      key: '/article/how_much_does_a_pool_cost'
    },
    {
      value: 'Bathroom Renovation',
      key: '/article/how_much_does_bathroom_renovation_cost'
    },
    {
      value: 'Building',
      key: '/article/calculate_your_building_costs'
    },
    {
      value: 'Rendering',
      key: '/article/how_much_does_rendering_cost'
    },
    {
      value: 'Concreting',
      key: '/article/how_much_does_concreting_cost'
    },
    {
      value: 'Painting',
      key: '/article/how_much_do_commercial_painters_cost'
    },
    {
      value: 'Plastering',
      key: '/article/how_much_does_plastering_cost'
    },
    {
      value: 'Pavers',
      key: '/article/how_much_does_concrete_paving_cost'
    },
    {
      value: 'Air Conditioners',
      key: '/article/how_much_does_air_conditioning_installation_cost'
    },
    {
      value: 'Handyman',
      key: '/article/how_much_does_a_handyman_cost'
    },
    {
      value: 'Fencing',
      key: '/article/how_much_does_fencing_cost_per_metre'
    },
    {
      value: 'Garages',
      key: '/article/how_much_does_a_garage_door_cost'
    }
  ]
};
